import axios from 'axios'
import { CONST_HEADER } from '@/api/config/default'
import { exportAxios } from '@/utils/axiosType'

const hashImportAxios = (url, params) => axios.create({
  headers: {
    ...CONST_HEADER(),
  },
  responseType: 'blob',
}).post(url, params)

export default {
  // 获取软件费用列表
  getCgFeeList(params) {
    return axios.post('/api/rendering/admin/task/config/getCgFeeList', params)
  },
  // 获取软件/插件名列表
  getCgFeeName(params) {
    return axios.post('/api/rendering/admin/task/config/getCgFeeName', params)
  },
  // 添加软件费用
  addCgFee(params) {
    return axios.post('/api/rendering/admin/task/config/addCgFee', params)
  },
  // 删除软件费用
  deleteCgFee(params) {
    return axios.post('/api/rendering/admin/task/config/deleteCgFee', params)
  },
  // 编辑软件费用
  editCgFee(params) {
    return axios.post('/api/rendering/admin/task/config/editCgFee', params)
  },
  // 软件费用导出
  exportChargeDataExcel(params) {
    return exportAxios('/api/rendering/admin/task/config/exportCgFeeExcel', params, 'get')
  },
  // 获取插件列表
  getPluginList(params) {
    return axios.post('/api/rendering/admin/task/config/getPluginList', params)
  },
  // 获取CG依赖列表
  getCgDependenceList(params) {
    return axios.post('/api/rendering/admin/task/config/cgDependence/list', params)
  },
  // 获取插件配置列表
  getPluginConfigList(params) {
    return axios.post('/api/rendering/admin/task/config/getCgPluginConfigList', params)
  },
  // Excel导入插件
  importExcelPlugin(params) {
    return axios.post('/api/rendering/admin/task/config/importPluginExcel', params)
  },
  // 下载Excel模板
  exportPluginTemplateExcel(params) {
    return exportAxios('/api/rendering/admin/task/config/exportPluginTemplateExcel', params, 'get')
  },
  // 插件数据导出
  exportPluginDataExcel(params) {
    return exportAxios('/api/rendering/admin/task/config/exportPluginExcel', params)
  },
  // 新增插件
  addPlugin(params) {
    return axios.post('/api/rendering/admin/task/config/addPlugin', params)
  },
  // 新增依赖
  addDependency(params) {
    return axios.post('/api/rendering/admin/task/config/cgDependence/add', params)
  },
  // 查询可用 Redis 平台列表
  queryRedisPlatformList() {
    return axios.post('/api/rendering/admin/task/platform/queryRedisPlatformList')
  },
  // 批量导入依赖 SHA
  batchAddCgDependenceHash(params) {
    return hashImportAxios('/api/rendering/admin/task/config/cgDependence/batchAdd', params)
  },
  // 批量导入软件配置 SHA
  syncCgVersionHash(params) {
    return hashImportAxios('/api/rendering/admin/task/config/syncCgVersionHash', params)
  },
  // 批量导入插件配置 SHA
  syncCgPluginHash(params) {
    return hashImportAxios('/api/rendering/admin/task/config/syncCgPluginHash', params)
  },
  // 编辑依赖 SHA
  editCgDependenceHash(params) {
    return axios.post('/api/rendering/admin/task/config/cgDependence/editHash', params)
  },
  // 编辑软件/插件依赖配置 SHA
  editDependenceConfigHash(params) {
    return axios.post('/api/rendering/admin/task/config/cgDependence/editDependenceConfigHash', params)
  },
  // 删除依赖
  deleteCgDependence(params) {
    return axios.post('/api/rendering/admin/task/config/cgDependence/delete', params)
  },
  // 编辑依赖配置
  editDependenceConfig(params) {
    return axios.post('/api/rendering/admin/task/config/cgDependence/editDependenceConfig', params)
  },
  // 新增插件配置
  addPluginConfig(params) {
    return axios.post('/api/rendering/admin/task/config/addCgPluginConfig', params)
  },
  // 新增软件依赖
  addSoftwareDependency(params) {
    return axios.post('/api/rendering/admin/task/config/addSoftwareDependency', params)
  },
  // 新增插件依赖
  addPluginDependency(params) {
    return axios.post('/api/rendering/admin/task/config/addPluginDependency', params)
  },
  // 编辑/启用/禁用/勾选插件
  dealPlugin(params) {
    return axios.post('/api/rendering/admin/task/config/editPlugin', params)
  },
  // 编辑插件配置
  editPluginConfig(params) {
    return axios.post('/api/rendering/admin/task/config/modifyCgPluginVersion', params)
  },
  // 编辑依赖配置
  editDependencyConfig(params) {
    return axios.post('/api/rendering/admin/task/config/modifyDependencyVersion', params)
  },
  // 删除插件
  deletePlugin(params) {
    return axios.post('/api/rendering/admin/task/config/deletePlugin', params)
  },
  // 删除插件配置
  deletePluginConfig(params) {
    return axios.post('/api/rendering/admin/task/config/deleteCgPluginConfig', params)
  },
  // 删除软件依赖配置
  deleteCgDependenceConfig(params) {
    return axios.post('/api/rendering/admin/task/config/cgDependence/deleteCgDependenceConfig', params)
  },
  // 约束配置
  // 获取约束列表
  getConstraintList(params) {
    return axios.post('/api/rendering/admin/task/config/getConstraintList', params)
  },
  // 获取存储类约束名
  storageConstraintName(params) {
    return axios.post('/api/rendering/admin/task/config/storageConstraintName', params)
  },
  // 增加和修改约束
  handleConstraint(params) {
    return axios.post('/api/rendering/admin/task/config/handleConstraint', params)
  },
  // 删除约束
  deleteConstraint(params) {
    return axios.post('/api/rendering/admin/task/config/deleteConstraint', params)
  },
  // 渲染脚本配置
  // 获取脚本操作列表
  getScriptVersionList(params) {
    return axios.post('/api/rendering/admin/task/config/getScriptVersionList', params)
  },
  // 编辑保存脚本
  saveScript(params) {
    return axios.post('/api/rendering/admin/task/config/saveScript', params)
  },
  // 应用脚本
  applyScript(params) {
    return axios.post('/api/rendering/admin/task/config/applyScript', params)
  },
  // 正在应用其他版本的平台
  getUsedVersion(params) {
    return axios.post('/api/rendering/admin/task/config/getUsedVersion', params)
  },
  // 获取软件列表
  getSoftware(params) {
    return axios.post('/api/rendering/admin/task/config/getCgVersionList', params)
  },
  // 获取软件配置列表
  getSoftwareConfig(params) {
    return axios.post('/api/rendering/admin/task/config/getCgVersionConfigList', params)
  },
  // 获取依赖配置列表
  getCgDependenceConfigList(params) {
    return axios.post('/api/rendering/admin/task/config/cgDependence/configList', params)
  },
  // 编辑软件配置状态
  editCgVersionConfigStatus(params) {
    return axios.post('/api/rendering/admin/task/config/editCgVersionConfigStatus', params)
  },
  // 编辑软件/插件配置参数
  editCgVersionConfigParams(params) {
    return axios.post('/api/rendering/admin/task/config/editCgVersionConfigParams', params)
  },
  // 新增软件
  addSoftware(params) {
    return axios.post('/api/rendering/admin/task/config/addCgVersion', params)
  },
  // 新增自定义软件
  addCustomizeCgVersion(params) {
    return axios.post('/api/rendering/admin/task/config/addCustomizeCgVersion', params)
  },
  // 新增软件配置
  addSoftwareConfig(params) {
    return axios.post('/api/rendering/admin/task/config/addCgVersionConfig', params)
  },
  // 编辑软件
  editSoftware(params) {
    return axios.post('/api/rendering/admin/task/config/editCgVersion', params)
  },
  // 编辑自定义提交软件
  editCustomizeCgVersion(params) {
    return axios.post('/api/rendering/admin/task/config/editCustomizeCgVersion', params)
  },
  // 删除软件
  deleteSoftware(params) {
    return axios.post('/api/rendering/admin/task/config/deleteCgVersion', params)
  },
  // 删除软件配置
  deleteSoftwareConfig(params) {
    return axios.post('/api/rendering/admin/task/config/deleteCgVersionConfig ', params)
  },
  // 删除任务调度频率列表
  deleteTaskScheduleList(params) {
    return axios.post('/api/rendering/admin/task/config/delTaskSchedule', params)
  },
  // 查询是否有关联插件
  queryIsHaveCgPlugin(params) {
    return axios.post('/api/rendering/admin/task/config/queryIsHaveCgPlugin', params)
  },
  // 新增活动
  insertActivities(params) {
    return axios.post('/api/rendering/admin/front/user/render/bonus/insert', params)
  },
  // 更新活动
  updateActivities(params) {
    return axios.post('/api/rendering/admin/front/user/render/bonus/update', params)
  },
  // 删除活动
  deleteActivities(params) {
    return axios.post('/api/rendering/admin/front/user/render/bonus/delete', params)
  },
  // 查询活动
  queryByCondition(params) {
    return axios.post('/api/rendering/admin/front/user/render/bonus/queryByCondition', params)
  },
  // 查询活动by ID
  queryByid(params) {
    return axios.post('/api/rendering/admin/front/user/render/bonus/queryById', params)
  },
  // 查询活动渲染券领取情况
  queryRecords(params) {
    return axios.post('/api/rendering/admin/front/user/render/bonus/receive/queryRecords', params)
  },
  // 新增活动渲染券
  addBonus(params) {
    return axios.post('/api/rendering/admin/front/user/render/bonus/addBonus', params)
  },
  // 导出活动渲染券
  exportExcelByCondition(params) {
    return exportAxios(
      '/api/rendering/admin/front/user/render/bonus/receive/exportExcelByCondition',
      params,
    )
  },
  // 获取错误信息配置列表
  getErrorList(
    params = {
      // pageNum: 0,           // [int] 页码
      // pageSize: 0,          // [int] 页面大小
      // code: '',             // [str option] 错误码
      // description: '',      // [str option] 问题描述
      // solution: '',         // [str option] 方案描述
      // isOpen: 0,            // [int option] 是否开启
      // type: 0,              // [int option] 错误码类型
      // isResolved: 0,        // [int option] 是否可修复
      // language: 0,          // [int option] 语言
    },
  ) {
    return axios.post('/api/rendering/admin/task/error/queryListByCondition', params)
  },
  // 新增错误信息配置
  addError(
    params = {
      // linkAddre: '',        // [str] 链接地址
      // code: '',             // [str] 错误码
      // description: '',      // [str] 问题描述
      // solution: '',         // [str] 方案描述
      // isOpen: 0,            // [int] 是否开启
      // type: 0,              // [int] 错误码类型
      // isResolved: 0,        // [int] 是否可修复
      // language: 0,          // [int] 语言
    },
  ) {
    return axios.post('/api/rendering/admin/task/error/add', params)
  },
  // 编辑错误信息配置
  editError(
    params = {
      // id: 0,                // [int] 错误id
      // linkAddre: '',        // [str] 链接地址
      // code: '',             // [str option] 错误码
      // description: '',      // [str option] 问题描述
      // solution: '',         // [str option] 方案描述
      // isOpen: 0,            // [int option] 是否开启
      // type: 0,              // [int option] 错误码类型
      // isResolved: 0,        // [int option] 是否可修复
      // language: 0,          // [int option] 语言
    },
  ) {
    return axios.post('/api/rendering/admin/task/error/edit', params)
  },
  // 删除错误信息配置
  delError(
    params = {
      // id: 0,                // [int] 错误id
    },
  ) {
    return axios.post('/api/rendering/admin/task/error/delete', params)
  },
  // 平台支持硬件型号查询接口
  queryHardwareByPlatform(params) {
    return axios.post('/api/rendering/admin/task/hardwareConfig/queryHardwareByPlatform', params)
  },
  // 查询数据字典列表
  getDataDictionaryList(params) {
    return axios.post('/api/rendering/admin/task/distion/queryByCondition', params)
  },
  // 新增数据字典
  addDataDictionary(params) {
    return axios.post('/api/rendering/admin/task/distion/add', params)
  },
  // 编辑数据字典
  editDataDictionary(params) {
    return axios.post('/api/rendering/admin/task/distion/update', params)
  },
  // 删除数据字典
  deleteDataDictionary(params) {
    return axios.post('/api/rendering/admin/task/distion/delete', params)
  },
  // 查询存储挂载列表
  getStorageList(params) {
    return axios.post('/api/rendering/admin/task/mount/path/queryByCondition', params)
  },
  // 新增存储挂载
  addStorage(params) {
    return axios.post('/api/rendering/admin/task/mount/path/addMountPath', params)
  },
  // 编辑存储挂载
  editStorage(params) {
    return axios.post('/api/rendering/admin/task/mount/path/updateMountPath', params)
  },
  // 删除存储挂载
  deleteStorage(params) {
    return axios.post('/api/rendering/admin/task/mount/path/deleteMountPath', params)
  },
  // 查询平台配置列表
  getPlatformList(params) {
    return axios.post('/api/rendering/admin/task/platform/queryByCondition', params)
  },
  queryAllByCondition() {
    return axios.post('/api/rendering/admin/task/platform/queryAllByCondition', {})
  },
  // 新增平台配置
  addPlatform(params) {
    return axios.post('/api/rendering/admin/task/platform/add', params)
  },
  // 编辑平台配置
  editPlatform(params) {
    return axios.post('/api/rendering/admin/task/platform/update', params)
  },
  // 删除平台配置
  deletePlatform(params) {
    return axios.post('/api/rendering/admin/task/platform/delete', params)
  },
  // 检查导入平台配置数据
  checkImportPlatformConfigData(params) {
    return axios.post('/api/rendering/admin/task/platform/checkImportPlatformConfigData', params)
  },
  // 导入批量新增平台配置
  addPlatformConfig(params) {
    return axios.post('/api/rendering/admin/task/platform/addPlatformConfig', params)
  },
  // 查询平台显示控制
  queryPlatformShowController(params) {
    return axios.post('/api/rendering/admin/task/platform/queryPlatformShowController', params)
  },
  // 显示控制回显
  getShowController(params) {
    return axios.post('/api/rendering/admin/task/platform/getShowController', params)
  },
  // 状态控制回显
  getStatusController(params) {
    return axios.post('/api/rendering/admin/task/platform/getStatusController', params)
  },
  // 提交控制回显
  getSubmitController(params) {
    return axios.post('/api/rendering/admin/task/platform/getSubmitController', params)
  },
  // 平台控制操作详情
  queryPlatformOperationDetails(params) {
    return axios.post('/api/rendering/admin/task/platform/queryPlatformOperationDetails', params)
  },
  // 设置显示控制
  settingShowController(params) {
    return axios.post('/api/rendering/admin/task/platform/settingShowController', params)
  },
  // 设置状态控制
  settingStatusController(params) {
    return axios.post('/api/rendering/admin/task/platform/settingStatusController', params)
  },
  // 设置提交控制
  settingSubmitController(params) {
    return axios.post('/api/rendering/admin/task/platform/settingSubmitController', params)
  },
  // 查询当前平台模式
  getCurrentPlatformMode() {
    return axios.post('/api/rendering/admin/task/platform/getCurrentPlatformMode')
  },
  // 切换平台为测试模式
  switchToTestMode(params) {
    return axios.post('/api/rendering/admin/task/platform/switchToTestMode', params)
  },
  // 恢复原平台提交设置
  restoreToNormalMode() {
    return axios.post('/api/rendering/admin/task/platform/restoreToNormalMode')
  },
  // 新增值班管理员
  addDutyAdmin(
    params = {
      // dutyCalendars: [{
      // adminName: '',        // [string] 管理员真实姓名
      // phone: '',            // [string] 管理员联系电话
      // dutyDate: '',         // [string] 值班的日期
      // organizationId: 0,    // [int] 值班所属部门id 4 TD 6 研发 7 运维
      // type: '',             // [int] 值班类型 不同organizationId对应不同（TD从1到4依次表示为：max产品线，maya产品线，Houdini+C4D产品线，Python；运维从1到2依次表示为：系统组，应用组；研发只有默认为1）
      // section: '',          // [int] 值班时间段，1为早班，2为中班，3为晚班
      // }]
    },
  ) {
    return axios.post('/api/rendering/admin/base/duty/addDutyAdmin', params)
  },
  // 根据部门id查询管理员列表
  queryAdminsByOrganizationIds(
    params = {
      organizationId: 1, // [int] 部门id
    },
  ) {
    return axios.post('/api/rendering/admin/base/user/queryAdminsByOrganizationIds', params)
  },
  // 同步值班日历
  synchroNailSchedule(params) {
    return axios.post('/api/rendering/admin/base/duty/synchroNailSchedule', params)
  },
  // 查询值管理员
  getDutyList(
    params = {
      // startTime: '',        // [string] 开始时间
      // endTime: '',          // [string] 结束时间
      // organizationId: 0,    // [int] 值班所属部门id 4 TD 6 研发 7 运维
    },
  ) {
    return axios.post('/api/rendering/admin/base/duty/getDutyList', params)
  },
  // 更新值班管理员
  updateDutyAdmin(
    params = {
      // id: 0,                // [int] id
      // adminName: '',        // [string] 管理员真实姓名
      // phone: '',            // [string] 管理员联系电话
      // dutyDate: '',         // [string] 值班的日期
      // section: 0,           // [int] 值班时间段，1为早班，2为中班，3为晚班
      // organizationId: 0,    // [int] 值班所属部门id 4 TD 6 研发 7 运维
      // type: 0,              // [int] 不同organizationId对应不同（TD从1到4依次表示为：max产品线，maya产品线，Houdini+C4D产品线，Python；运维从1到2依次表示为：系统组，应用组；研发只有默认为1）
    },
  ) {
    return axios.post('/api/rendering/admin/base/duty/updateDutyAdmin', params)
  },
  // 删除值班管理员
  deleteDutyAdmin(
    params = {
      // id: 0,                // [int] id
    },
  ) {
    return axios.post('/api/rendering/admin/base/duty/deleteDutyAdmin', params)
  },
  // 查询值班备注
  queryRemarks(
    params = {
      // organizationId: 0,    // [int] 值班所属部门id 4 TD 6 研发 7 运维
    },
  ) {
    return axios.post('/api/rendering/admin/base/duty/queryRemarks', params)
  },
  // 新增值班备注
  addRemark(
    params = {
      // organizationId: 0,    // [int] 值班所属部门id 4 TD 6 研发 7 运维
      // type: 0,              // [int] 渲染顾问部门1-3分别表示TD、Python、CS，运维1-3分别表示系统机器组、应用和网络组、贵安机房组，研发为1
      // remark: 0,            // [string] 备注内容
    },
  ) {
    return axios.post('/api/rendering/admin/base/duty/addRemark', params)
  },
  // 更新值班备注
  updateRemark(
    params = {
      // id: 0,                // [int] 对应接口返回的备注id
      // remark: 0,            // [string] 备注内容
    },
  ) {
    return axios.post('/api/rendering/admin/base/duty/updateRemark', params)
  },
  // 查看最新10条管理员公告信息
  latestAdministratorMessage(params) {
    return axios.post('/api/rendering/admin/base/bulletin/getAdminBulletinList', params)
  },
  // 查看管理员公告历史修改信息
  getAdminBulletinHistory(params) {
    return axios.post('/api/rendering/admin/base/bulletin/getAdminBulletinHistory', params)
  },
  // 新增管理员公告
  addAdminBulletin(params) {
    return axios.post('/api/rendering/admin/base/bulletin/addAdminBulletin', params)
  },
  // 编辑管理员公告
  editAdminBulletin(params) {
    return axios.post('/api/rendering/admin/base/bulletin/updateAdminBulletin', params)
  },
  // 删除管理员公告
  deleteAdminBulletin(params) {
    return axios.post('/api/rendering/admin/base/bulletin/deleteAdminBulletin', params)
  },
  // 获取客户端推广通知列表
  getClientNoticeList(params) {
    return axios.post('/api/rendering/admin/front/promotion/getNoticeList', params)
  },
  // 新增客户端推广通知
  addClientNotice(params) {
    return axios.post('/api/rendering/admin/front/promotion/addNotice', params)
  },
  // 编辑客户端推广通知
  updateClientNotice(params) {
    return axios.post('/api/rendering/admin/front/promotion/updateNotice', params)
  },
  // 删除客户端推广通知
  deleteClientNotice(params) {
    return axios.post('/api/rendering/admin/front/promotion/deleteNotice', params)
  },
  // 查询汇率列表
  checkExchangeRateList(params) {
    return axios.post('/api/rendering/admin/front/pay/config/rate/queryList', params)
  },
  // 更新汇率
  updateRate(params) {
    return axios.post('/api/rendering/admin/front/pay/config/rate/updateRate', params)
  },
  // 获取客户端系统通知
  getClientSystemNotice(params) {
    return axios.post('/api/rendering/admin/front/sysnotice/getSysNoticeList', params)
  },
  // 新增客户端系统通知
  addClientSystemNotice(params) {
    return axios.post('/api/rendering/admin/front/sysnotice/addSysNotice', params)
  },
  // 更新客户端系统通知
  updateClientSystemNotice(params) {
    return axios.post('/api/rendering/admin/front/sysnotice/updateSysNotice', params)
  },
  // 删除客户端系统通知
  deleteClientSystemNotice(params) {
    return axios.post('/api/rendering/admin/front/sysnotice/deleteSysNotice', params)
  },
  // 获取营销活动列表
  getMarketingActivities() {
    return axios.get('/api/rendering/admin/front/pay/config/activity/queryList')
  },
  // 编辑营销活动
  editMarketingActivity(params) {
    return axios.post('/api/rendering/admin/front/pay/config/activity/updateActivity', params)
  },
  // 获取充值类型
  getAllPayMethod() {
    return axios.get('/api/rendering/admin/front/user/activity/template/getAllPayMethod')
  },
  // 上传文件
  uploadFile(params) {
    return axios.post('/api/rendering/admin/front/user/activity/template/uploadFile', params, {
      headers: {
        'content-type': 'multipart/form-data;',
      },
    })
  },
  // 新建活动模板
  addActivityTemplate(params) {
    return axios.post('/api/rendering/admin/front/user/activity/template/add', params)
  },
  // 查询活动模板列表
  getActivityTemplateList(params) {
    return axios.post('/api/rendering/admin/front/user/activity/template/list', params)
  },
  // 修改活动模板
  updateActivityTemplate(params) {
    return axios.post('/api/rendering/admin/front/user/activity/template/update', params)
  },
  // 获取活动模板
  getActivityTemplate(params) {
    return axios.post('/api/rendering/admin/front/user/activity/template/getActivityById', params)
  },
  // 修改活动模板状态
  updateActivityStatus(params) {
    return axios.post(
      '/api/rendering/admin/front/user/activity/template/updateActivityStatus',
      params,
    )
  },
  // 获取奖品池活动列表
  getAwardActivities(params) {
    return axios.post('/api/rendering/admin/front/user/festivalactivity/getActivities', params)
  },
  // 添加奖品池活动
  addAwardActivity(params) {
    return axios.post('/api/rendering/admin/front/user/festivalactivity/addActivity', params)
  },
  // 编辑奖品池活动
  editAwardActivity(params) {
    return axios.post('/api/rendering/admin/front/user/festivalactivity/editActivity', params)
  },
  // 删除奖品池活动
  deleteAwardActivity(params) {
    return axios.post('/api/rendering/admin/front/user/festivalactivity/deleteActivity', params)
  },
  // 获取活动奖品列表
  getActivityPrizes(params) {
    return axios.post('/api/rendering/admin/front/user/festivalactivity/getActivityPrize', params)
  },
  // 增加活动奖品
  addActivityPrize(params) {
    return axios.post('/api/rendering/admin/front/user/festivalactivity/addActivityPrize', params)
  },
  // 编辑活动奖品
  editActivityPrize(params) {
    return axios.post('/api/rendering/admin/front/user/festivalactivity/editActivityPrize', params)
  },
  // 删除活动奖品
  deleteActivityPrize(params) {
    return axios.post(
      '/api/rendering/admin/front/user/festivalactivity/deleteActivityPrize',
      params,
    )
  },
  // 获取用户中奖记录
  getUserAwardRecord(params) {
    return axios.post('/api/rendering/admin/front/user/festivalactivity/getUserPrize', params)
  },
  // 用户兑奖
  exchangePrize(params) {
    return axios.post('/api/rendering/admin/front/user/festivalactivity/exchangePrize', params)
  },
  // 客户端版本（王顺辉）
  getClientChannel() {
    return axios.post('/api/rendering/admin/front/promotion/getClientChannel')
  },
  // 查询软件附加收费
  queryCgSoftAdditionalPrice(params) {
    return axios.post('/api/rendering/admin/task/config/queryCgSoftAdditionalPrice', params)
  },
  // 新增软件附加收费
  addCgSoftAdditionalPrice(params) {
    return axios.post('/api/rendering/admin/task/config/addCgSoftAdditionalPrice', params)
  },
  // 编辑软件附加收费
  editCgSoftAdditionalPrice(params) {
    return axios.post('/api/rendering/admin/task/config/editCgSoftAdditionalPrice', params)
  },
  // 删除附加收费
  deleteAdditionalPrice(params) {
    return axios.post('/api/rendering/admin/task/config/deleteAdditionalPrice', params)
  },
  // 查询插件附加收费
  queryCgPluginAdditionalPrice(params) {
    return axios.post('/api/rendering/admin/task/config/queryCgPluginAdditionalPrice', params)
  },
  // 新增插件附加收费
  addCgPluginAdditionalPrice(params) {
    return axios.post('/api/rendering/admin/task/config/addCgPluginAdditionalPrice', params)
  },
  // 编辑插件附加收费
  editCgPluginAdditionalPrice(params) {
    return axios.post('/api/rendering/admin/task/config/editCgPluginAdditionalPrice', params)
  },
  // 查询软件/插件支持的系统
  queryOsNamesByCgInfo(params) {
    return axios.post('/api/rendering/admin/task/config/queryOsNamesByCgInfo', params)
  },
  // 查询软件/插件支持的平台
  queryPlatformsByCgInfo(params) {
    return axios.post('/api/rendering/admin/task/config/queryPlatformsByCgInfo', params)
  },
  // 根据软件版本查询插件名称列表
  queryPluginNameByCgVersion(params) {
    return axios.post('/api/rendering/admin/task/config/queryPluginNameByCgVersion', params)
  },
  // 根据软件版本和插件名称查询插件版本列表
  queryPluginVersionByPluginName(params) {
    return axios.post('/api/rendering/admin/task/config/queryPluginVersionByPluginName', params)
  },
  // 添加软件属性，要求，约束
  addCgVersionConfigParams(params) {
    return axios.post('/api/rendering/admin/task/config/addCgVersionConfigParams ', params)
  },
  // 查询单个软件 属性/要求/约束
  getCgVersionConfigParams(params) {
    return axios.post('/api/rendering/admin/task/config/getCgVersionConfigParams', params)
  },
  // 删除软件属性，要求，约束
  deleteCgVersionConfigParams(params) {
    return axios.post('/api/rendering/admin/task/config/deleteCgVersionConfigParams', params)
  },
  // 查询单个插件 属性/要求/约束
  getCgPluginConfigParams(params) {
    return axios.post('/api/rendering/admin/task/config/getCgPluginConfigParams', params)
  },
  // 添加插件属性，要求，约束
  addCgPluginConfigParams(params) {
    return axios.post('/api/rendering/admin/task/config/addCgPluginConfigParams', params)
  },
  // 删除插件属性，要求，约束
  deleteCgPluginConfigParams(params) {
    return axios.post('/api/rendering/admin/task/config/deleteCgPluginConfigParams', params)
  },
  // 给软件版本分配支持的平台
  allocatePlatform(params) {
    return axios.post('/api/rendering/admin/task/config/allocatePlatform', params)
  },
  // 给软件版本分配支持的系统
  allocateOS(params) {
    return axios.post('/api/rendering/admin/task/config/allocateOS', params)
  },
  // 分配平台
  pluginAllocatePlatform(params) {
    return axios.post('/api/rendering/admin/task/config/plugin/allocatePlatform', params)
  },
  // 分配系统
  pluginAllocateOS(params) {
    return axios.post('/api/rendering/admin/task/config/plugin/allocateOS', params)
  },
  // 分配软件版本
  allocateCV(params) {
    return axios.post('/api/rendering/admin/task/config/plugin/allocateCV', params)
  },
  // 修改插件状态
  modifyOpenStatus(params) {
    return axios.post('/api/rendering/admin/task/config/modifyOpenStatus', params)
  },
  // 软件的下拉框列表
  getCgVersionControlPullSelect(params) {
    return axios.post('/api/rendering/admin/task/config/getCgVersionControlPullSelect', params)
  },
  // 插件的下拉框列表
  getCgPluginControlPullSelect(params) {
    return axios.post('/api/rendering/admin/task/config/getCgPluginControlPullSelect', params)
  },
  // 新增调度记录：
  addPlatformOrAreaSchedule(params) {
    return axios.post('/api/rendering/admin/task/config/addPlatformOrAreaSchedule', params)
  },
  // 修改：
  updateTaskSchedule(params) {
    return axios.post('/api/rendering/admin/task/config/updateTaskSchedule', params)
  },
  // 查询：
  getPlatformOrAreaScheduleList(params) {
    return axios.post('/api/rendering/admin/task/config/getPlatformOrAreaScheduleList', params)
  },
  // 查询通知设置列表.
  getNotificationSettingList(params) {
    return axios.post('/api/rendering/admin/front/notification/getNotificationSettingList', params)
  },
  // 根据id查询通知设置.
  getNotificationSetting(params) {
    return axios.post('/api/rendering/admin/front/notification/getNotificationSetting', params)
  },
  // 编辑通知设置.
  editNotificationSetting(params) {
    return axios.post('/api/rendering/admin/front/notification/editNotificationSetting', params)
  },
  // 根据删除通知设置.
  deleteNotificationSetting(params) {
    return axios.post('/api/rendering/admin/front/notification/deleteNotificationSetting', params)
  },
  // 添加通知设置.
  addNotificationSetting(params) {
    return axios.post('/api/rendering/admin/front/notification/addNotificationSetting', params)
  },
  // 年终活动--增加备注
  addPrizeRemark(params) {
    return axios.post('/api/rendering/admin/front/user/activity/template/addPrizeRemark', params)
  },
  // 年终活动--查询获奖详情列表
  getActivityPrizeDetailList(params) {
    return axios.post(
      '/api/rendering/admin/front/user/activity/template/getActivityPrizeDetailList',
      params,
    )
  },
  // 年终活动--导出获奖详情列表
  exportActivityPrizeDetail(params) {
    return axios.post(
      '/api/rendering/admin/front/user/activity/template/exportActivityPrizeDetail',
      params,
    )
  },
  // 年终活动--年终活动奖品列表
  getActivityPrizeList(params) {
    return axios.post(
      '/api/rendering/admin/front/user/activity/template/getActivityPrizeList',
      params,
    )
  },
  // 年终活动--上传兑奖excel
  uploadUserPrizeInfo(params) {
    return axios.post(
      '/api/rendering/admin/front/user/activity/template/uploadUserPrizeInfo',
      params,
    )
  },
  // 年终活动--充值记录列表
  getActivityPayRecordList(params) {
    return axios.post(
      '/api/rendering/admin/front/user/activity/template/getActivityPayRecordList',
      params,
    )
  },
  // 年终活动--充值记录列表导出
  exportActivityPayRecordList(params) {
    return axios.post(
      '/api/rendering/admin/front/user/activity/template/exportActivityPayRecordList',
      params,
    )
  },
  // 年终活动--调查问卷导出
  exportQuestionnaire(params) {
    return axios.post(
      '/api/rendering/admin/front/user/activity/template/exportQuestionnaire',
      params,
    )
  },
  // 年终活动--导入备注文件
  importActivityRemarks(params) {
    return axios.post(
      '/api/rendering/admin/front/user/activity/template/importActivityRemarks',
      params,
    )
  },
  // 年终活动--作陪
  invalidCoupon(params) {
    return axios.post('/api/rendering/admin/front/user/activity/template/invalidCoupon', params)
  },
  // 下载模板
  templateDownload(params) {
    return exportAxios('/api/rendering/admin/front/user/activity/template/templateDownload', params)
  },
  // 查询年终活动充值金额
  getActivityRechargeAmount(params) {
    return axios.post(
      '/api/rendering/admin/front/user/activity/template/getActivityRechargeAmount',
      params,
    )
  },
  getMachineRoomByMunuIp(params) {
    return axios.post('/api/rendering/admin/task/platform/getMachineRoomByMunuIp', params)
  },
  queryOverData(params) {
    return axios.post('/api/rendering/admin/front/user/activity/template/queryOverData', params)
  },
  queryDetailVisitor(params) {
    return axios.post(
      '/api/rendering/admin/front/user/activity/template/queryDetailVisitor',
      params,
    )
  },
  queryClickDetail(params) {
    return axios.post('/api/rendering/admin/front/user/activity/template/queryClickDetail', params)
  },
  exportOverData(params) {
    return exportAxios('/api/rendering/admin/front/user/activity/template/exportOverData', params)
  },
  exportVisitorDetail(params) {
    return exportAxios(
      '/api/rendering/admin/front/user/activity/template/exportVisitorDetail',
      params,
    )
  },
  exportClickDetail(params) {
    return exportAxios(
      '/api/rendering/admin/front/user/activity/template/exportClickDetail',
      params,
    )
  },
  // 客户端内置广告
  getPicAdvertiseList(params) {
    return axios.post('/api/rendering/admin/front/promotion/getPicAdvertiseList', params)
  },
  addPicAdvertise(params) {
    return axios.post('/api/rendering/admin/front/promotion/addPicAdvertise', params)
  },
  editPicAdvertise(params) {
    return axios.post('/api/rendering/admin/front/promotion/editPicAdvertise', params)
  },
  exportPicAdvertise(params) {
    return exportAxios('/api/rendering/admin/front/promotion/exportPicAdvertise', params)
  },
  deletePicAdvertise(params) {
    return axios.post('/api/rendering/admin/front/promotion/deletePicAdvertise', params)
  },
  // 小程序内置广告
  getMiniProgramAdvertiseList(params) {
    return axios.post('/api/rendering/admin/front/promotion/getMiniProgramAdvertiseList', params)
  },
  addMiniProgramAdvertise(params) {
    return axios.post('/api/rendering/admin/front/promotion/addMiniProgramAdvertise', params)
  },
  editMiniProgramAdvertise(params) {
    return axios.post('/api/rendering/admin/front/promotion/editMiniProgramAdvertise', params)
  },
  exportMiniProgramAdvertise(params) {
    return exportAxios('/api/rendering/admin/front/promotion/exportMiniProgramAdvertise', params)
  },
  deleteMiniProgramAdvertise(params) {
    return axios.post('/api/rendering/admin/front/promotion/deleteMiniProgramAdvertise', params)
  },
  addDutyTimeSlot(params) {
    return axios.post('/api/rendering/admin/base/duty/addDutyTimeSlot', params)
  },
  getDutyTimeSlot(params) {
    return axios.post('/api/rendering/admin/base/duty/getDutyTimeSlot', params)
  },
  // 概览页广告
  getOverviewAdvertiseList(params) {
    return axios.post('/api/rendering/admin/front/promotion/getOverviewAdvertiseList', params)
  },
  addOverviewAdvertise(params) {
    return axios.post('/api/rendering/admin/front/promotion/addOverviewAdvertise', params)
  },
  editOverviewAdvertise(params) {
    return axios.post('/api/rendering/admin/front/promotion/editOverviewAdvertise', params)
  },
  exportOverviewAdvertise(params) {
    return exportAxios('/api/rendering/admin/front/promotion/exportOverviewAdvertise', params)
  },
  deleteOverviewAdvertise(params) {
    return axios.post('/api/rendering/admin/front/promotion/deleteOverviewAdvertise', params)
  },
  // 泛cg管理
  queryCgtalksList(params) {
    return axios.post('/api/rendering/admin/front/user/cgInfo/query', params)
  },
  remarkCgtalks(params) {
    return axios.post('/api/rendering/admin/front/user/cgInfo/remark', params)
  },
  exportCgtalks(params) {
    return axios.post('/api/rendering/admin/front/user/cgInfo/export', params)
  },
  // 获取错误信息配置列表
  getRenderErrorList(params) {
    return axios.post('/api/rendering/admin/task/renderError/queryListByCondition', params)
  },
  // 新增错误信息配置
  addRenderError(params) {
    return axios.post('/api/rendering/admin/task/renderError/add', params)
  },
  // 编辑错误信息配置
  editRenderError(params) {
    return axios.post('/api/rendering/admin/task/renderError/edit', params)
  },
  // 删除错误信息配置
  delRenderError(params) {
    return axios.post('/api/rendering/admin/task/renderError/delete', params)
  },
  // 获取背景图列表
  getBackgroundList(params) {
    return axios.post('/api/rendering/admin/front/background/getBackgroundList', params)
  },
  addBackground(params) {
    return axios.post('/api/rendering/admin/front/background/addBackground', params)
  },
  deleteBackground(params) {
    return axios.post('/api/rendering/admin/front/background/deleteBackground', params)
  },
  updateBackground(params) {
    return axios.post('/api/rendering/admin/front/background/updateBackground', params)
  },
  uploadPicture(params) {
    return axios.post('/api/rendering/admin/front/background/uploadPicture', params)
  },
  queryGroup() {
    return axios.post('/api/rendering/admin/front/user/group/queryGroup')
  },
  deleteGroup(params) {
    return axios.post('/api/rendering/admin/front/user/group/deleteGroup', params)
  },
  updateGroup(params) {
    return axios.post('/api/rendering/admin/front/user/group/updateGroup', params)
  },
  addGroup(params) {
    return axios.post('/api/rendering/admin/front/user/group/addGroup', params)
  },
  // 获取邀请码列表
  getInviteCodeList(params) {
    return axios.post('/api/rendering/admin/front/user/inviteCode/list', params)
  },
  // 新增邀请码
  addInviteCode(params) {
    return axios.post('/api/rendering/admin/front/user/inviteCode/add', params)
  },
  // 编辑邀请码
  editInviteCode(params) {
    return axios.post('/api/rendering/admin/front/user/inviteCode/edit', params)
  },
  // 启用/停用邀请码
  updateStatusInviteCode(params) {
    return axios.post('/api/rendering/admin/front/user/inviteCode/enableOrDisable', params)
  },
  // 根据邀请码id查询邀请码信息
  getInviteCodeDetailById(params) {
    return axios.get('/api/rendering/admin/front/user/inviteCode/selectById', { params })
  },
  // 获取操作日志
  getInviteCodeLogs(params) {
    return axios.get('/api/rendering/admin/front/user/inviteCode/getLogs', { params })
  },
  // 获取邀请码列表详情列表
  getInviteCodeDetailList(params) {
    return axios.post('/api/rendering/admin/front/user/inviteCode/registerDetailList', params)
  },
  // 导出注册邀请码列表
  exportInviteCodeList(params) {
    return exportAxios('/api/rendering/admin/front/user/inviteCode/exportInviteCodeList', params)
  },
  // 导出注册/充值详情列表
  exportInviteCodeDetailList(params) {
    return exportAxios('/api/rendering/admin/front/user/inviteCode/exportDetail', params)
  },
  // 新增活动模板关联钉钉审批号接口
  activityUpdateActivityNailApprovalNumber(params) {
    return axios.post('/api/rendering/admin/front/user/activity/template/updateActivityNailApprovalNumber', params)
  },
  // 新增渲染券管理关联钉钉审批号接口
  renderUpdateActivityNailApprovalNumber(params) {
    return axios.post('/api/rendering/admin/front/user/render/bonus/updateActivityNailApprovalNumber', params)
  },
  // 新增渲染券管理启用活动接口
  launchActivity(params) {
    return axios.post('/api/rendering/admin/front/user/render/bonus/launchActivity', params)
  },
  // 新增渲染券管理停用活动接口
  closingActivity(params) {
    return axios.post('/api/rendering/admin/front/user/render/bonus/closingActivity', params)
  },
  // 查询效果图客户端轮播图列表
  getSlideshowList(params) {
    return axios.post('/api/rendering/admin/front/promotion/getPicCarouselList', params)
  },
  // 新增效果图客户端轮播图
  addSlideshow(params) {
    return axios.post('/api/rendering/admin/front/promotion/addPicCarousel', params)
  },
  // 修改效果图客户端轮播图
  editSlideshow(params) {
    return axios.post('/api/rendering/admin/front/promotion/editPicCarousel', params)
  },
  // 删除效果图客户端轮播图
  deleteSlideshow(params) {
    return axios.post('/api/rendering/admin/front/promotion/deletePicCarousel', params)
  },
  // 导出效果图客户端轮播图曝光量和点击
  exportSlideshow(params) {
    return axios.post('/api/rendering/admin/front/promotion/exportPicCarouselStats', params)
  },
  // 注册邀请码管理关联钉钉审批号接口
  updateInviteCodeNailApprovalNumber(params) {
    return axios.post('/api/rendering/admin/front/user/inviteCode/updateInviteCodeNailApprovalNumber', params)
  },
  // 查询json文件模板配置列表
  queryJsonFileTemplateConfigList(params) {
    return axios.post('/api/rendering/admin/task/config/queryJsonFileTemplateConfigList', params)
  },
  // 编辑-根据id查询json文件模板表单配置
  queryJsonFileTemplateFieldConfigById(params) {
    return axios.post('/api/rendering/admin/task/config/queryJsonFileTemplateFieldConfigById', params)
  },
  // 新增json文件模板字段
  addJsonFileTemplateFieldConfigById(params) {
    return axios.post('/api/rendering/admin/task/config/addJsonFileTemplateFieldConfigById', params)
  },
  // 编辑json文件模板字段
  editJsonFileTemplateFieldConfigById(params) {
    return axios.post('/api/rendering/admin/task/config/editJsonFileTemplateFieldConfigById', params)
  },
  // 删除json文件模板字段
  deleteJsonFileTemplateFieldConfigById(params) {
    return axios.post('/api/rendering/admin/task/config/deleteJsonFileTemplateFieldConfigById', params)
  },
  // 查询前置后置任务列表
  queryDependencyTask(params) {
    return axios.post('/api/rendering/admin/task/dependency/queryDependencyTask', params)
  },
  // 新增前置后置任务
  addDependencyTask(params) {
    return axios.post('/api/rendering/admin/task/dependency/addDependencyTask', params)
  },
  // 编辑前置后置任务
  updateDependentTask(params) {
    return axios.post('/api/rendering/admin/task/dependency/updateDependencyTask', params)
  },
  // 删除前置后置任务
  deleteDependencyTask(params) {
    return axios.post('/api/rendering/admin/task/dependency/deleteDependencyTask', params)
  },
  // 查询用户平台控制
  queryPlatformUserLimit(params) {
    return axios.post('/api/rendering/admin/task/platform/queryPlatformUserLimit', params)
  },
  // 新增用户平台控制
  addPlatformUserLimit(params) {
    return axios.post('/api/rendering/admin/task/platform/addPlatformUserLimit', params)
  },
  // 编辑用户平台控制
  editPlatformUserLimit(params) {
    return axios.post('/api/rendering/admin/task/platform/updatePlatformUserLimit', params)
  },
  // 删除用户平台控制
  deletePlatformUserLimit(params) {
    return axios.post('/api/rendering/admin/task/platform/deletePlatformUserLimit', params)
  },
}
